/// <reference path="../../../../../typings.d.ts" />

import { Component } from '@angular/core';
import 'file-saver';
import { ContractsHttpService } from '../../../../services/contracts/contracts.http.service';
import { ForSigningHttpService } from '../../../../services/forsigning/forsigning.http.service';
import { ContractsHttpUtil } from '../contracts.util';
import { StorageUtil } from '../../../../utils/storage.util';
import * as moment from 'moment';
import { ContractModelService } from '../contracts.model.service';
import { AuthUtil } from '../../../../utils/auth.utils';
import { Router } from '@angular/router';
import { ReportHttpService } from '../../../../services/report/report.http.service';
import { DashboardHttpUtil } from '../../dashboard.util';
import { CALENDAR_LOCALE_RU } from '../../../../consts/locale';
import {DevelopUtil} from '../../../../utils/develop.utils';

@Component({
  moduleId: module.id,
  templateUrl: 'contracts.list.component.html',
  providers: []
})

export class ContractsListComponent {

  model = [];
  search: any = '';
  searchList = [];
  typeList = [
    {label: 'Адрес', value: 'address'},
    {label: 'Кадастровый номер', value: 'cadastre'},
    {label: 'Номер документа', value: 'docNum'},
    {label: 'Дата документа', value: 'docDate'},
  ];
  type = this.typeList[0].value;
  isSearch = false;
  pageSize = 10;
  pageNumber = 0;
  totalPages = 1;
  showClosed = 0;
  infinityScrollDisabled = false;
  loadBtnStatus;

  pageLoading = true;
  errorMessage: string;
  serverValidationErrorMessage: any;

  currentYear:any = new Date().getFullYear();
  getContractsSubscription: any;

  fileName = 'summary';

  localeRu = CALENDAR_LOCALE_RU;

  contractsForSigningCount = 0;

  constructor(private contractHttpService: ContractsHttpService, private forSigningHttpService: ForSigningHttpService, private contractModelService: ContractModelService, private authUtil: AuthUtil, private router: Router, private reportHttpService: ReportHttpService) {
    this.getContractsForSigningCount();
    this.getContracts();
  }

  ngOnInit() {
    const accrualsConfig = {
      futureAccruals: 0,
      payedAccruals: 0,
    };
    this.contractModelService.setAccrualsConfig(accrualsConfig);

    window.onresize = function() {
        const table = document.querySelector('.pane-vScroll');
        if (table) {
          table.setAttribute('style', 'width: 100%');
        }
    };
  }

  getContractsForSigningCount() {
    const data = {
      securityToken: StorageUtil.getToken(),
    };
    
    const requestParams = ContractsHttpUtil.prepareParamsContracts(data);
    this.forSigningHttpService.getContractsForSigningCount(requestParams).subscribe(
      success => {
            const data = success.json().response;
            this.contractsForSigningCount = data.count;
      },
      error => {
        this.contractsForSigningCount = 0;
      }
    );
  }

  getContracts() {

    this.errorMessage = '';
    this.pageLoading = true;

    const data = {
      securityToken: StorageUtil.getToken(),
      pageSize:   this.pageSize,
      pageNumber: this.pageNumber,
      showClosed: this.showClosed,
      address: '',
      cadastre: '',
      docDate: '',
      docNum: '',
    };

    if (this.isSearch) {
      let value = this.search;

      if (this.type === 'docDate' && typeof(value) !== 'undefined' && value.length) {
        value = moment(value).utcOffset(0, true).format('YYYY-MM-DD');
      }

      // set field of searching
      data[this.type] = value;
    }

    if(data['docDate'] !== '') {
      data['docDate'] = moment(data['docDate']).utcOffset(0, true).format('YYYY-MM-DD');
    }
    const requestParamsP = ContractsHttpUtil.prepareParamsContracts(data);
    this.contractHttpService.getPaginationContract(requestParamsP).subscribe(
        success => {
              const data = success.json().response;
              this.totalPages = Math.ceil(data.all / this.pageSize);
              if (this.totalPages < 0) {
                 this.totalPages = 1;
              }
        },
        error => { 
          this.totalPages = 1
        },
        () => {
    if(data['docDate'] !== '') {
      data['docDate'] = moment(data['docDate']).utcOffset(0, true).format('YYYY-MM-DD');
    }
    const requestParams = ContractsHttpUtil.prepareParamsContracts(data);
    this.getContractsSubscription = this.contractHttpService.getContracts(requestParams).subscribe(
      success => {
        if (success) {
          this.pageLoading = false;
          const data = success.json();
          if (this.authUtil.isError(data)) {
            this.errorMessage = this.authUtil.errorMessage(data);
            this.authUtil.checkErrorResponse(data);
          } else {
            // TODO: refactoring
            if (this.isSearch) {
              // Done for infinite scroll get nex data - request save the search Value without click search func;
              if (!this.search) {
                this.isSearch = false;
              }
              this.searchList = data.response && data.response.items || [];
              this.infinityScrollDisabled = false;
            } else {
              this.model = data.response && data.response.items || [];
              this.searchList = this.model;
            }

            if (this.searchList.length > 0) {
              this.loadBtnStatus = true;
            }
          }
        }
      }, error => {
        console.log(error);
        if (error.status === 422) {
          this.serverValidationErrorMessage = error.json().errors;
        } else {
          // this.errorMessage = 'Произошла ошибка.';
        }
        this.searchList = [];
        this.pageLoading = false;
        this.loadBtnStatus = true;
      },
      () => {
        this.pageLoading = false;
      });
    }
    );
  }

  toSearch(event) {
    if(typeof event.preventDefault === 'function') {
      event.preventDefault();
    }
    this.isSearch = true;
    this.pageNumber = 0;
    this.getContracts();
  }

  loadNextContracts() {
    this.infinityScrollDisabled = true;
    this.pageNumber += 1;
    // TODO: refactoring
    this.getNextContracts();
  }

  getNextContracts() {
    // TODO: scroll loading status

    this.errorMessage = '';

    const data = {
      securityToken: StorageUtil.getToken(),
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      showClosed: this.showClosed,
      address: '',
      cadastre: '',
      docDate: '',
      docNum: '',
    };

    if (this.isSearch) {
      // set field of searching
      data[this.type] = this.type === 'docDate' ? moment(this.search).utcOffset(0, true).format('YYYY-MM-DD') : this.search;
    }

    const requestParams = ContractsHttpUtil.prepareParamsContracts(data);
    this.getContractsSubscription = this.contractHttpService.getContracts(requestParams).subscribe(
      success => {
        if (success) {
          // TODO: scroll loading status
          this.pageLoading = false;
          const data = success.json();
            if (this.authUtil.isError(data)) {
                this.errorMessage = this.authUtil.errorMessage(data);
                this.authUtil.checkErrorResponse(data);
            } else {
            const searchList = data.response && data.response.items || [];
            this.searchList.push.apply(this.searchList, searchList);
            this.infinityScrollDisabled = false;
            this.loadBtnStatus = searchList.length > 0;
          }
        }
      },
      error => {
        console.log(error);
        if (error.status === 422) {
          this.serverValidationErrorMessage = error.json().errors;
        } else {
          // this.errorMessage = 'Произошла ошибка.';
        }
        // TODO: scroll loading status
        this.pageLoading = false;
        this.loadBtnStatus = true;
      },
      () => {
        // TODO: scroll loading status
        this.pageLoading = false;
      });
  }

  toggleShowClosed(status) {
    if (this.getContractsSubscription) {
      this.getContractsSubscription.unsubscribe();
    }
    this.pageNumber = 0;
    if (status) {
      this.showClosed = 1;
    } else {
      this.showClosed = 0;
    }
    this.getContracts();
  }

  navigate($event, id) {
    $event.preventDefault();
    this.pageLoading = true;
    this.router.navigate(['contracts/' + id + '/accruals']);
  }

  handleChangeSearchType($event) {
    if (this.search instanceof Date && $event.value !== 'docDate') {
        this.search = moment(this.search).utcOffset(0, true).format('DD/MM/YYYY');
        this.search = $event.value === 'docDate' ? new Date() : this.search;
    } else {
        this.clearSearchFilter($event);
    }
  }

  downloadSummary($event) {
      $event.preventDefault();
      this.pageLoading = false;
      this.errorMessage = '';

      const dataSummary = {
        securityToken: StorageUtil.getToken(),
        showClosed: this.showClosed,
        address: '',
        cadastre: '',
        docDate: '',
        docNum: ''
      };

      if (this.isSearch) {
        let value = this.search;

        if (this.type === 'docDate' && value.length) {
          value = moment(value).utcOffset(0, true).format('YYYY-MM-DD');
        }

        // set field of searching
        dataSummary[this.type] = value;
      }

      window.open(DevelopUtil.url('report/summaryInfo?' + ContractsHttpUtil.prepareParamsContracts(dataSummary).toString()), '_blank');
  }

  clearSearchFilter($event): void {
    this.search = '';
    this.toSearch($event);
  }

  isContractOverpayment(arrears): boolean {
    return arrears < 0;
  }

  getClassStateContractArrears(arrears): string {
    return this.isContractOverpayment(arrears) ? 'green' : 'red';
  }

  parseFloatIfString(value) {
    if ((typeof value) === "string") {
      return parseFloat(value);
    } else {
      return value;
    }
  }

  formatPrice(price) {
    if ((typeof price) === "string") {
      price = parseFloat(price)
    }
    if (price > 0) {
      return price;
    } else {
      return parseFloat(String(price).replace('-', ''));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/list/contracts.list.component.ts